import styled from 'styled-components';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';

export const StyledDots = styled.div`
  width: 20px;
  text-align: left;
  margin-left: 4px;
`;

export const StyledCloseIcon = styled(SvgIcon)`
  position: absolute;
  top: 20px;
  right: 20px;
  user-select: none;
`;
